"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountByUserId = void 0;
var axios_1 = __importDefault(require("axios"));
var GET_COUNT_BY_USERID = '/payment/countByUserId';
/**
 * @deprecated ApiPayment.getCountByUserId() 를 사용할 것 !!!
 * 결제 횟수 획득
 * @param token
 */
var getCountByUserId = function (token) {
    return new Promise(function (resolve, reject) {
        // resolve(HomeParser(HomeData));
        var config = {
            method: 'get',
            url: GET_COUNT_BY_USERID,
            responseType: 'json',
            headers: {
                token: token,
            },
        };
        axios_1.default
            .request(config)
            .then(function (res) {
            resolve(res.data.data);
        })
            .catch(function (err) {
            reject(err);
        });
    });
};
exports.getCountByUserId = getCountByUserId;
